import React from 'react';
import style from '../css/Stats.module.css';

function Stats() {
	return (
		<section className={style.wrapper}>
			<div className={style.statBox}>
				<h3 className={style.number}>1K+</h3>
				<p className={style.label}>Unique Tours</p>
			</div>
			<div className={style.statBox}>
				<h3 className={style.number}>10K+</h3>
				<p className={style.label}>Happy Travelers</p>
			</div>
			<div className={style.statBox}>
				<h3 className={style.number}>4.8+</h3>
				<p className={style.label}>App Store Rating</p>
			</div>
		</section>
	);
}

export default Stats;
